import { useNavigate } from "react-router-dom";
import { NavigationHistoryService } from "../services/navigation-history-service";

export const useHistoryNavigate = () => {
  const navigate = useNavigate();
  const navigationHistoryService = new NavigationHistoryService();

  const historyNavigate = (section, id) => {
    const navigationHistory = navigationHistoryService.get(section);
    if(!navigationHistory) return;

    navigate(`/${section}${id ? `/${id}` : ""}${navigationHistory}`);
  };

  return {
    historyNavigate,
    navigationHistoryService
  };
};
